/** Dashboard release. The research paper has its own document version. */
export const APP_VERSION = "0.1.0";
export const APP_VERSION_LABEL = `v${APP_VERSION}`;
